__turbopack_context__.v({
  "containerWidth": "dTak3a_containerWidth",
});
